
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termos-e-condicoes-para-vendedores",
      function () {
        return require("private-next-pages/termos-e-condicoes-para-vendedores/index.ts");
      }
    ]);
  